import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router';
import swal from 'sweetalert';
import useFetchApi from '../../../services/CustomHook/useFetchApi';
import PopulatefsCashFlowTable from './populateFsCashFlowTable';

const PopulateFsCashFlow = (props) => {
    const {subsiaryData}=props;
    console.log(subsiaryData,"subsiaryDatasubsiaryDatasubsiaryData");
    let history = useHistory();
    const project_id = localStorage.getItem('project_id');
    const { loading, response, error } = useFetchApi(`api/v1/cashflow/${project_id}`);

    const [cashFlow, setCashFlow] = useState([]);

    useEffect(() => {
        if (response && Object.keys(response).length > 0) {
            setCashFlow(response?.data?.data);
        }
        if (error) {
            swal("Error", error, "error");
        }
    }, [response || error])

   

    return (
        <>
            <div className='d-flex mr-2 justify-content-end' style={{ gap: "1rem" }}>
                <button className='my-2 rounded deleteBtn' style={{ border: "none", backgroundColor: "white" }}
                    onClick={() => { history.push(`/financialstatement/cashflow/working`) }}
                >
                    <div className='px-4 py-2' style={{ color: "#03565a", fontWeight: "600" }}>Cash Flow workings</div>
                </button>
            </div>
            <PopulatefsCashFlowTable data={cashFlow} />
        </>
    )
}

export default PopulateFsCashFlow